import { render, staticRenderFns } from "./InspectionStandardList.vue?vue&type=template&id=a05b8554&"
import script from "./InspectionStandardList.vue?vue&type=script&lang=js&"
export * from "./InspectionStandardList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionStandardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports